export const defaultValues = {
    subject    : "",
    to         : "",
    cc         : [],
    bcc        : [],
    attachments: [],
    body       : ""
};

export const getEmailReplies = (emails, threadId) => {
    if (!emails.length || !threadId) return [];
    const replies = emails
        .filter(
            (email) => email.subject.startsWith("Re: ") && email.thread_id === threadId
        )
        .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());

    return replies;
};

export const extractName = (to) => {
    const entry = to.trim();
    const match = entry.match(/^(.+?)\s*<\s*([^>]+)\s*>$/);

    if (match) {
        return {
            name : match[1].trim(),
            email: match[2].trim()
        };
    }
};